import AnalisiRischiList from "./components/AnalisiRischiList";
import AnalisiRischiView from "./components/AnalisiRischiView";
import AnalisiRischiEdit from "./components/AnalisiRischiEdit";
export default {
    AnalisiRischiList,
    AnalisiRischiView,
    AnalisiRischiEdit,
};
